import { get } from "../util/utilFunc";

export const searchTwilioNumbers = async (phoneNumber, city, state, areaCode) => {
    const res = await get(`/office/twilioNumber?phoneNumber=${phoneNumber}&city=${city}&state=${state}&areaCode=${areaCode}`, {});

    return res;
};